import { ApiProperty } from "@nestjs/swagger";

export class ContainerLogBookIdRequestDto {
    @ApiProperty()
    containerLogBookId: number;
}